import { useEffect, useContext } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import GlobalContext from '../../../contexts';
import translating from '../translate.json';
import fields from '../fields';
import { useNavigate } from 'react-router-dom';

const CreateProduct = () => {
  const navigate = useNavigate();
  const { postData, res } = usePostData();
  const { categoriesList, setLink } = useContext(GlobalContext);

  useEffect(() => {
    if (res?.id) {
      setLink(null);
      navigate(`/products?added=true`);
    }
  }, [res]);

  const onSubmit = (data) => {
    console.log(data);
    if (data.discountType === 'אחוז') {
      data.maxPercentDiscountAmount = data.discountMaxValue;
      data.maxFixedDiscountAmount = data.price * (data.discountMaxValue / 100);
    } else {
      data.maxPercentDiscountAmount =
        (data.discountMaxValue / data.price) * 100;
      data.maxFixedDiscountAmount = data.discountMaxValue;
    }
    if (data.parentId === 1)
      data.numberOfAppointments = data.numberOfAppointments || 2;
    else if (data.parentId === 2) {
      data.numberOfAppointments = data.numberOfAppointments || 3;
    } else if (data.parentId === 3) {
      data.numberOfAppointments = 5;
    }
    postData('product', data);
  };
  return (
    <div className="create-product">
      <SectionHeader title={translating.createProduct}></SectionHeader>
      <FormGroup
        fields={fields(categoriesList)}
        onSubmit={onSubmit}
        categories={categoriesList}
      ></FormGroup>
    </div>
  );
};

export default CreateProduct;
